import Route from '@ember/routing/route';

export default class MonitorRoute extends Route 
{
}
